<template>
  <div class="container flex" style="margin-bottom: 30px;">
    <div>
      <left></left>
    </div>
    <div class="live flex1" style="margin-left: 20px;">
    			<div class="title">
    				联系我们
    			</div>
    			<div class="content" style="padding: 20px;line-height: 1.8;">

              <div v-html="data"></div>


    			</div>
    		</div>
  </div>
</template>

<script>
  import left from './accountleft.vue'
  export default {
    name: 'Footer',
    components:{
      left
    },
    data () {
      return {
          data:''
      }
    },
    methods:{
      getData(){
        this.$axios.post(this.$common.about_url+'?aboutId=6').then((res)=>{
              if(res.data.code==1){
                this.data=res.data.data;
              }
              else {
                alert(res.data.msg)
              }
        })
      }
    },
    created(){
      this.getData()
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/concat.vue